import React, { useState } from 'react'
import { Bar } from 'react-chartjs-2';


function SalesGraph2() {
  // Sample data for demonstration

  const [isarea, setisarea] = useState(true)
  const [isdonut, setisdonut] = useState(false)

  const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
    datasets: [
      {
        label: 'Mail Orders',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(255, 99, 132, 0.7)',
        hoverBorderColor: 'rgba(255, 99, 132, 1)',
        data: [65, 59, 80, 81, 56, 55],
      },
      {
        label: 'Online Sales',
        backgroundColor: 'rgba(54, 162, 235, 0.5)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(54, 162, 235, 0.7)',
        hoverBorderColor: 'rgba(54, 162, 235, 1)',
        data: [28, 48, 40, 19, 86, 27],
      },
      {
        label: 'In-store Sales',
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(75, 192, 192, 0.7)',
        hoverBorderColor: 'rgba(75, 192, 192, 1)',
        data: [35, 45, 60, 51, 36, 25],
      },
    ],
  };

  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };


  const areafunction =()=>{
    setisarea(true)
    setisdonut(false)
  }

  const donutFunction =()=>{
    setisdonut(true)
    setisarea(false)
  }

  return (
    <>
    {/* <div style={{width:"50%",height:300}}>
      <h2>Sales Graph</h2>
      <Bar data={data} options={options} />
    </div> */}

<div className="card" style={{width:"50%"}}>
<div className="card-header">
  <h3 className="card-title">
    <i className="fas fa-chart-pie mr-1" />
    Sales
  </h3>
  <div className="card-tools">
    <ul className="nav nav-pills ml-auto">
      <li className="nav-item">
        <button
          className={`nav-link ${isarea && "active"}`}
          onClick={areafunction}
          style={{color:'#fff',marginRight:5}}
        >
          Area
        </button>
      </li>
      <li className="nav-item">
        <button
          className={`nav-link ${isdonut && "active"}`}
          onClick={donutFunction}
          style={{color:'#fff'}}
        >
          Donut
        </button>
      </li>
    </ul>
  </div>
</div>
<Bar data={data} options={options} />
</div>
</>
  );
}

export default SalesGraph2